// File: src/app/admin/settings/containers/SettingListContainer.jsx
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Spin from 'antd/lib/spin';
import {
  selectSettingsInCategories,
  selectInterestSettings,
  selectInterestSettingsHistory,
  fetchSettingsActions,
  fetchInterestSettingsActions,
  updateInterestSettingsActions,
  fetchInterestSettingsHistoryActions,
  fetchGeneralContractHistoryActions,
  selectGeneralContractHistory,
  newGeneralContractEntryActions
} from '../ducks';
import { SettingList } from '../components';
import { apiCallIds as settingApiCallIds } from '../api';
import { selectIsInProgress } from '../../../features/spinner/ducks';

// ---- PSD2 aggregation ducks (admin) ----
import {
  // selectors
  selectPsd2Categories,
  selectPsd2AggregationCriteria,
  // categories
  fetchPsd2CategoriesActions,
  createPsd2CategoryActions,
  updatePsd2CategoryActions,
  deletePsd2CategoryActions,
  // aggregation criteria
  fetchPsd2AggregationCriteriaActions,
  createPsd2AggregationCriteriaActions,
  updatePsd2AggregationCriteriaActions,
  deletePsd2AggregationCriteriaActions,
} from '../../psd2/ducks';

const mapStateToProps = state => ({
  settingsInCategories: selectSettingsInCategories(state),
  generalContractHistory: selectGeneralContractHistory(state),
  interestSettings: selectInterestSettings(state),
  interestSettingsHistory: selectInterestSettingsHistory(state),
  isLoading: selectIsInProgress(state, settingApiCallIds.FETCH_SETTINGS),
  isUpdatingInterestSettings: selectIsInProgress(state, settingApiCallIds.UPDATE_INTEREST_SETTINGS),

  // PSD2 aggregation
  psd2Categories: selectPsd2Categories(state),
  psd2AggregationCriteria: selectPsd2AggregationCriteria(state),
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      fetchSettings: fetchSettingsActions.request,
      fetchInterestSettings: fetchInterestSettingsActions.request,
      fetchInterestSettingsHistory: fetchInterestSettingsHistoryActions.request,
      updateInterestSettings: updateInterestSettingsActions.request,
      fetchGeneralContractHistory: fetchGeneralContractHistoryActions.request,
      newGeneralContractEntry: newGeneralContractEntryActions.request,

      // PSD2 aggregation — categories
      fetchPsd2Categories: fetchPsd2CategoriesActions.request,
      createPsd2Category: createPsd2CategoryActions.request,
      updatePsd2Category: updatePsd2CategoryActions.request,
      deletePsd2Category: deletePsd2CategoryActions.request,

      // PSD2 aggregation — criteria
      fetchPsd2AggregationCriteria: fetchPsd2AggregationCriteriaActions.request,
      createPsd2AggregationCriteria: createPsd2AggregationCriteriaActions.request,
      updatePsd2AggregationCriteria: updatePsd2AggregationCriteriaActions.request,
      deletePsd2AggregationCriteria: deletePsd2AggregationCriteriaActions.request,
    },
    dispatch
  ),
});

@connect(mapStateToProps, mapDispatchToProps)
export default class SettingListContainer extends Component {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    settingsInCategories: PropTypes.object.isRequired,
    interestSettings: PropTypes.array.isRequired,
    generalContractHistory: PropTypes.array.isRequired,
    isLoading: PropTypes.bool.isRequired,
    isUpdatingInterestSettings: PropTypes.bool.isRequired,

    // PSD2 aggregation
    psd2Categories: PropTypes.array,
    psd2AggregationCriteria: PropTypes.array,
  };

  componentWillMount() {
    this.setState({
      interestSettingsHistory: [],
    });
  }

  componentDidMount() {
    const { actions } = this.props;
    actions.fetchSettings();
    actions.fetchInterestSettings();
    actions.fetchInterestSettingsHistory();
    actions.fetchGeneralContractHistory();

    // Optional: preload PSD2 aggregation data so the tab is instant
    actions.fetchPsd2Categories({});
    actions.fetchPsd2AggregationCriteria({});
  }

  addNewEntry = (role) =>  {
    let dateUpdated = new Date();
    this.props.actions.newGeneralContractEntry({ dateUpdated: dateUpdated, role: role });
    this.setState({ newEntry: dateUpdated });
  }

  onSubmitInterestSettings = interestSettings => {
    this.props.actions.updateInterestSettings({ interestSettings });
    const now = Date.now();
    for (let i = 0; i < this.props.interestSettings.length; i++) {
      this.props.interestSettings[i].updatedAt = now;
    }
    this.setState({
      interestSettingsHistory: this.props.interestSettings.concat(this.state.interestSettingsHistory),
    });
  };

  render() {
    const {
      settingsInCategories,
      interestSettings,
      isLoading,
      isUpdatingInterestSettings,
      interestSettingsHistory,
      generalContractHistory,

      // PSD2 aggregation
      psd2Categories,
      psd2AggregationCriteria,
      actions,
    } = this.props;

    let history = [];
    if (this.state && this.state.interestSettingsHistory){
      history = [...this.state.interestSettingsHistory];
    }
    history = history.concat(interestSettingsHistory);

    const categories = Object.entries(settingsInCategories);

    if (!categories.length) {
      return (
        <Spin spinning={isLoading}>
          <div className="spin-empty-content" />
        </Spin>
      );
    }

    return (
      <SettingList
        categories={Object.entries(settingsInCategories)}
        interestSettings={interestSettings}
        interestSettingsHistory={history}
        onSubmitInterestSettings={this.onSubmitInterestSettings}
        isUpdatingInterestSettings={isUpdatingInterestSettings}
        generalContractHistory={generalContractHistory}
        addNewEntry={this.addNewEntry}

        // PSD2 aggregation props -> component calls these on mount and on actions
        psd2Categories={psd2Categories}
        psd2AggregationCriteria={psd2AggregationCriteria}
        onFetchPsd2Categories={actions.fetchPsd2Categories}
        onCreatePsd2Category={actions.createPsd2Category}
        onUpdatePsd2Category={actions.updatePsd2Category}
        onDeletePsd2Category={actions.deletePsd2Category}
        onFetchAggregationCriteria={actions.fetchPsd2AggregationCriteria}
        onCreateAggregationCriteria={actions.createPsd2AggregationCriteria}
        onUpdateAggregationCriteria={actions.updatePsd2AggregationCriteria}
        onDeleteAggregationCriteria={actions.deletePsd2AggregationCriteria}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/setting-management/containers/SettingListContainer.js